import * as React from "react";
import classNames from "classnames";
import { BaseComponent } from "../../react-core/Html/BaseComponent";
import { JsonDateParser } from "../../react-core/Utils/JsonDateParser";
import { ServiceProposition } from "../../Wrap/Constants/Enums/ServiceProposition";
import { UserClaim } from "../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Action } from "../Dashboard/Actions/Action";
import { RestrictionReasonStore } from "../Dashboard/Components/Clients/PortfolioDashboard/Store/Variables";
import { StaticUrls } from "../Dashboard/Resoures/StaticUrls";
import { ClientAccountStore } from "../Dashboard/Stroes/Variable";
import { Permission } from "../Shared/Permission/Permission";
import { getQueryParameters } from "../Shared/Wizards/Entities/QueryParametersHelper";
import { InvestorType } from "../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";

interface IClientDashboardHeaderProps extends React.Props<ClientDashboardHeader> {}

interface IClientDashboardHeaderState {
    clientInfo: ClientAccount;
    restrictionReason: any;
    data: any;
    customerId: string;
    hideBackToSummary: boolean;
}

export class ClientDashboardHeader extends BaseComponent<IClientDashboardHeaderProps, IClientDashboardHeaderState> {
    constructor(props: any) {
        super(props);

        const params = getQueryParameters();
        this.state = {
            clientInfo: ClientAccountStore.getClientAccountInfo(),
            restrictionReason: null,
            data: null,
            customerId: "",
            hideBackToSummary: params["hidebacktosummary"] === "true",
        };
        this.subscribeToStore(RestrictionReasonStore, () => this.onRestrictionReasonStoreChange());
    }

    componentDidMount() {
        this.getData();
    }

    private onRestrictionReasonStoreChange(): void {
        const data = RestrictionReasonStore.getData();
        this.setState({ restrictionReason: data });
    }

    private getData() {
        //RestrictionReasonAction.getAccountRestrictions(this.state.clientInfo.HierarchyId);
        if (this.state.clientInfo?.InvestorType == InvestorType.Consolidated) {
            this.setState({ customerId: this.state.clientInfo?.HierarchyId });
        } else {
            Action.searchClientsByAccount(this.state.clientInfo.HeadClAccountId, (val) => {
                this.setState({ customerId: val });
            });
        }
    }

    public render(): JSX.Element {
        const { data, restrictionReason } = this.state;
        let clAccountId = null;
        if (data) {
            clAccountId = data.clAccountId;
        }
        const accountName = this.state.clientInfo?.AccountName;
        const accountServicePropositionId = this.state.clientInfo?.AccountServicePropositionId;
        const diffDays = this.getDateDifference();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        let canView;
        let reason;
        if (restrictionReason) {
            reason = restrictionReason.ReasonName;
            canView = restrictionReason.CanView;
        }
        return (
            <>
                <div className="flex-space align-items-end">
                    <div>
                        <div className="row narrow-gutter">
                            <div className="col-auto">
                                <h1
                                    className={classNames(
                                        "client-name-heading",
                                        accountServicePropositionId == ServiceProposition.Fundzone ? "isFz" : ""
                                    )}
                                >
                                    <span>{accountName}</span>
                                </h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-auto">
                                <span className="text-muted text-size-14 mb-0 mr-20">
                                    <b>{clAccountId}</b>
                                </span>

                                {canView && (
                                    <span className="text-muted text-size-14 mb-0 mr-20">
                                        {[reason ? "Restriction: " + reason : "Restriction: N/A"]}
                                    </span>
                                )}

                                {/* <button className="client-portal-view mr-20">
                                    <span className="icon" aria-hidden="true"></span>
                                    {clientDashboardHeaderContents.lastLoginLabel(diffDays)}
                                </button> */}
                            </div>
                        </div>
                        {console.log("CustomerId: " + this.state.customerId)}
                        {this.state.hideBackToSummary === false && (
                            <div className="row mt-11">
                                <div className="col-auto">
                                    {this.state.customerId != "" && (
                                        <Permission userClaim={UserClaim.AdviserPortalPerformanceSummaryCanView}>
                                            <a
                                                onClick={() => {
                                                    window.location.assign(
                                                        StaticUrls.ClientDashboardUrl(this.state.customerId, "summary")
                                                    );
                                                }}
                                                className="hyperlink-previous"
                                            >
                                                <span className="icon" aria-hidden={true}></span>
                                                <span className="text">Back to summary</span>
                                            </a>
                                        </Permission>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <hr className="mt-6" />
            </>
        );
    }

    private getDateDifference(): number {
        const date1 = new Date();
        const date2 = JsonDateParser.toDate(new Date());
        const diffDays = Math.floor(
            (Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate()) -
                Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate())) /
                (1000 * 60 * 60 * 24)
        );
        return diffDays;
    }
}
